import styled from 'styled-components';

export const GalleryNavItem = styled.div`
  cursor: pointer;
  outline: none;
  padding-right: .5rem;
`;
